import React, { FC } from 'react';

const ratings = {
	'ESRB_E': 'ESRB_2018_E.svg',
	'ESRB_E10': 'ESRB_2018_E10.svg',
	'ESRB_T': 'ESRB_2018_T.svg',
	'ESRB_M': 'ESRB_2018_M.svg',
	'ESRB_RP': 'ESRB_2018_RP.svg',
	'CLASSIND_LIVRE': 'DJCTQ_-_L.png',
	'CLASSIND_6_ANOS': 'DJCTQ_-_6.png',
	'CLASSIND_10_ANOS': 'DJCTQ_-_10.png',
	'CLASSIND_12_ANOS': 'DJCTQ_-_12.png',
	'CLASSIND_14_ANOS': 'DJCTQ_-_14.png',
	'CLASSIND_16_ANOS': 'DJCTQ_-_16.png',
	'CLASSIND_18_ANOS': 'DJCTQ_-_18.png',
} as Record<string, string>;

const convertToKey = (board: string, rating: string) => {
	if (board.toUpperCase() === 'ESRB') {
		// E10+	
		// ESRB E10+	
		// EVERYONE 10+1
		// Everyone 10+
		if (/EVERYONE[\s_]10|10\+/ig.test(rating)) {
			return 'ESRB_E10';
		// ESRB E	
		// E
		// Everyone	
		// EVERYONE
		} else if (/EVERYONE|(\s|^)E$/i.test(rating)) {
			return 'ESRB_E';
		// ESRB T	
		// T	
		// TEEN	
		// Teen
		} else if (/ESRB\sT|TEEN|\sT$/i.test(rating)) {
			return 'ESRB_T';
		// ESRB M
		// M
		// MATURE
		// Mature
		// Mature 17+
		} else if (/MATURE|\sM$/i.test(rating)) {
			return 'ESRB_M';
		// RATING PENDING
		// RP-E	
		// RP-E10+		
		// RP
		} else if (/RATING PENDING|RP/ig.test(rating)) {
			return 'ESRB_RP';
		}
	} else if (board.toUpperCase() === 'CLASSIND') {
		// Classificação Livre
		// Classifica��o Livre
		// Livre
		// Livre (General Audiences)
		if (/livre/i.test(rating)) {
			return 'CLASSIND_LIVRE';
		// Classificação 6 anos
		// 6
		// 6 anos
		} else if (/(\s|^)6(\s|$)/i.test(rating)) {
			return 'CLASSIND_6_ANOS';
		// Classificação 10 anos
		// 10
		// 10 anos
		} else if (/(\s|^)10(\s|$)/i.test(rating)) {
			return 'CLASSIND_10_ANOS';
		// Classificação 12 anos
		// 12
		// 12 anos
		} else if (/12/i.test(rating)) {
			return 'CLASSIND_12_ANOS';
		// Classificação 14 anos
		// 14
		// 14 anos
		} else if (/14/i.test(rating)) {
			return 'CLASSIND_14_ANOS';
		// Classificação 16 anos
		// 16
		// 16 anos
		} else if (/16/i.test(rating)) {
			return 'CLASSIND_16_ANOS';
		// Classificação 18 anos
		// 18
		// 18 anos
		} else if (/18/i.test(rating)) {
			return 'CLASSIND_18_ANOS';
		}
	}
};

interface RatingGraphicProps {
	board: string;
	rating: string;
	className?: string;
}
const RatingGraphic: FC<RatingGraphicProps> = ({ board, rating, className }) => {
	const filename = ratings[convertToKey(board, rating)||'no'];
	if (filename) {
		return <img className={className} src={`/images/ratings/${filename}`} width="64" alt={`${rating} graphic`} />;
	}
	return null;
};

export default RatingGraphic;
